import { configureStore } from '@reduxjs/toolkit';
import settingsReducer from './slices/settingsSlice';
import authReducer from './slices/authSlice';
import logsReducer from './slices/logsSlice';
import appSliceReducer from './slices/appSlice';
import loudnessLogsReducer from './slices/loudnessLogsSlice';
import loudnessReducer from './slices/loudnessSlice';
import loudnessSettingsReducer from './slices/loudnessSettingsSlice';
import cuePointsReducer from './slices/cuePointsSlice';
import cuePointsSettingsReducer from './slices/cuePointsSettingsSlice';
import cuePointsLogsReducer from './slices/cuePointsLogsSlice';
import infoReducer from './slices/infoSlice';
import MusicPlayerReducer from './slices/musicPlayerSlice';
import fixSettingsReducer from './slices/fixSettingsSlice';
import organizerReducer from './slices/organizerSlice';
import organizerSettingsReducer from './slices/organizerSettingsSlice';
import organizerLogsReducer from './slices/organizerLogsSlice';
import playlistReducer from './slices/playlistSlice';
import fixMetadataReducer from './slices/fixMetadataSlice';
import rekordboxReducer from './slices/rekordboxSlice';
import seratoReducer from './slices/seratoSlice';
import traktorReducer from './slices/traktorSlice';
import virtualdjReducer from './slices/virtualdjSlice';
import migrationReducer from './slices/migrationSlice';
import djpalReducer from './slices/djpalSlice';
import smartRecsReducer from './slices/smartRecsSlice';
import whatsNextReducer from './slices/whatsNextSlice';
import aiSetReducer from './slices/aiSetSlice';
import automixReducer from './slices/automixSlice';
import automixSettingsReducer from './slices/automixSettingsSlice';
import tierReducer from './slices/tierSlice';
import likesReducer from './slices/likesSlice';
import likedMixesReducer from './slices/likedMixesSlice';
import followedArtistsReducer from './slices/followedArtistsSlice';
import followedLabelsReducer from './slices/followedLabelsSlice';
import feedReducer from './slices/feedSlice';
import notificationsReducer from './slices/notificationsSlice';
import djLibraryChangesReducer from './slices/djLibraryChangesSlice';
import djAutoSyncReducer from './slices/djAutoSyncSlice';
import searchHistoryReducer from './slices/searchHistorySlice';
import listContextReducer from './slices/listContextSlice';
import reportReducer from './slices/reportSlice';
import settingsMiddleware from "./middlewares/settingsMiddleware";
import navHistoryMiddleware from "./middlewares/navHistoryMiddleware";
import cueHistoryMiddleware from "./middlewares/cueHistoryMiddleware";

const store = configureStore({
    reducer: {
        app: appSliceReducer,
        settings: settingsReducer,
        auth: authReducer,
        logs: logsReducer,
        loudnessLogs: loudnessLogsReducer,
        loudness: loudnessReducer,
        loudnessSettings: loudnessSettingsReducer,
        cuePoints: cuePointsReducer,
        cuePointsSettings: cuePointsSettingsReducer,
        cuePointsLogs: cuePointsLogsReducer,
        info: infoReducer,
        musicPlayer: MusicPlayerReducer,
        fixSettings: fixSettingsReducer,
        organizer: organizerReducer,
        organizerSettings: organizerSettingsReducer,
        organizerLogs: organizerLogsReducer,
        playlist: playlistReducer,
        fixMetadata: fixMetadataReducer,
        rekordbox: rekordboxReducer,
        serato: seratoReducer,
        traktor: traktorReducer,
        virtualdj: virtualdjReducer,
        migration: migrationReducer,
        djpal: djpalReducer,
        smartRecs: smartRecsReducer,
        whatsNext: whatsNextReducer,
        aiSet: aiSetReducer,
        automix: automixReducer,
        automixSettings: automixSettingsReducer,
        tier: tierReducer,
        likes: likesReducer,
        likedMixes: likedMixesReducer,
        followedArtists: followedArtistsReducer,
        followedLabels: followedLabelsReducer,
        feed: feedReducer,
        notifications: notificationsReducer,
        djLibraryChanges: djLibraryChangesReducer,
        djAutoSync: djAutoSyncReducer,
        searchHistory: searchHistoryReducer,
        listContext: listContextReducer,
        report: reportReducer,
    },
    middleware: (getDefaultMiddleware) => [
        // immutableCheck + serializableCheck are dev-only and walk the
        // ENTIRE Redux state tree on every dispatch. With our state
        // (feed of 150 items, enrichedFiles potentially in the thousands,
        // tier/likes/follows/playlists/etc.) each scan costs 30-80ms,
        // and a typical startup fires 100+ dispatches → ~5-8s of pure JS
        // overhead that doesn't exist in production. Profiler caught a
        // 5388ms LONG TASK at startup directly attributable to these.
        // Disabling: they're already absent in prod builds, and the
        // safety they offer (catching state mutations, non-serializable
        // values) is replaceable with code review + occasional one-off
        // enablement if a mutation bug is suspected.
        ...getDefaultMiddleware({
            immutableCheck: false,
            serializableCheck: false,
        }),
        navHistoryMiddleware.middleware,
        settingsMiddleware, // Add your custom middleware
        cueHistoryMiddleware, // undo/redo for cue & loop edits
    ]
});

// Expose store for beforeunload settings save
window.__reduxStore = store;

export default store;
